import * as Endpoints from "../entities/Endpoints";
import axiosInstance from "../services/axiosInstance";

export const fetchChatBotResponseAPI = async (payload) => {
  const response = await axiosInstance.post(
    Endpoints.GET_CHAT_BOT_DETAILS,
    payload,
  );
  return response.data;
};

export const updateExerciseDetailsOnSessionId = async (payload) => {
  const response = await axiosInstance.post(
    Endpoints.UPDATE_EXERCISE_DETAILS_ON_SESSION_ID,
    payload,
  );
  return response.data;
};
